import React from 'react';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error('Unhandled UI error', error, errorInfo);
	}

	componentDidUpdate(prevProps) {
		// Recover on navigation so one broken page does not follow the user
		// around for the rest of the session.
		if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
			this.setState({ hasError: false });
		}
	}

	render() {
		if (this.state.hasError) {
			return (
				this.props.fallback || (
					<div className="alert alert-warning">
						This page could not be displayed. Reload to try again,
						or contact support if it keeps happening.
					</div>
				)
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
